import { Capacitor } from '@capacitor/core';

export function getPlatform() {
  return Capacitor.getPlatform();
}

export function isNativePlatform() {
  return Capacitor.isNativePlatform();
}

export function isIos() {
  return getPlatform() === 'ios';
}

export function isAndroid() {
  return getPlatform() === 'android';
}

export function getPlatformClassName() {
  if (!isNativePlatform()) return 'platform-web';
  return `platform-native platform-${getPlatform()}`;
}
